export { default } from './Link';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Link/index.js
// module id = 550
// module chunks = 2